export const eventsWithoutNotification = ['driver_location_update']

export const eventsWithoutAvatar = [
  'created',
  'failed_to_deliver',
  'driver_pool_fallback',
]

export const eventsWithActionButtons = ['driver_pool_fallback']
